import React, { useState } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import MatchbaseLogo from "@/components/brand/MatchbaseLogo";

// One footer for every public page: night navy, hairline borders, small uppercase column labels.
const COLUMNS = [
  { title: "For teams", links: [["/tournaments", "Find a tournament"], ["/live", "Live scores"], ["/find", "How it works"]] },
  { title: "For organisers", links: [["/organisers", "Features"], ["/organisers#pricing", "Pricing"], ["/organisers#demo", "Book a demo"]] },
  { title: "Company", links: [["/about", "About"], ["/about#contact", "Contact"]] },
];

export default function SiteFooter() {
  const [lang, setLang] = useState(() => { try { return localStorage.getItem("site_lang") || "en"; } catch { return "en"; } });
  function switchLang(l) {
    try { localStorage.setItem("site_lang", l); } catch { /* private mode */ }
    setLang(l);
  }
  return (
    <footer className="bg-[#0B1630] text-white">
      <div className="mx-auto grid max-w-[1200px] gap-10 px-4 py-16 text-sm sm:grid-cols-2 md:grid-cols-[1.4fr_repeat(3,1fr)] lg:px-6">
        <div>
          <MatchbaseLogo tone="dark" height={32} />
          <p className="mt-4 max-w-[260px] text-sm font-light leading-relaxed text-white/60">Find, book and run youth football tournaments, all in one place.</p>
          <div className="mt-5 flex w-max rounded-full border border-white/10 p-0.5 text-xs font-medium" role="group" aria-label="Language">
            {["en", "th"].map((l) => (
              <button key={l} onClick={() => switchLang(l)} aria-pressed={lang === l}
                className={cn("h-8 rounded-full px-3 uppercase tracking-[0.08em]", lang === l ? "bg-white text-[#0B1630]" : "text-white/70 hover:text-white")}>{l}</button>
            ))}
          </div>
        </div>
        {COLUMNS.map((c) => (
          <div key={c.title}>
            <h3 className="text-[11px] font-medium uppercase tracking-[0.14em] text-white/50">{c.title}</h3>
            <ul className="mt-4 space-y-2.5 text-white/75">
              {c.links.map(([to, label]) => <li key={to}><Link to={to} className="transition-colors hover:text-white">{label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/[0.08] py-5 text-center text-xs font-light text-white/50">© 2026 Matchbase</div>
    </footer>
  );
}
